import { AccessibilityRole, Platform } from 'react-native'

// TODO https://cardohealth.atlassian.net/browse/CAR-1318

// Possible values for native: https://reactnative.dev/docs/view#accessibilityrole and https://reactnative.dev/docs/accessibility#accessibilityrole
// Possible values for web: https://www.w3.org/TR/wai-aria-1.2/#role_definitions
export const A11Role = {
  // NativeBase has 'dialog' for web, see https://docs.nativebase.io/action-sheet#h2-accessibility
  Actionsheet: Platform.select({ default: 'alert', web: 'dialog' }) as AccessibilityRole,
  // NativeBase has 'dialog' for web, see https://github.com/GeekyAnts/NativeBase/blob/85df9009fde1e845ae46024c6a54630368be9e2b/src/components/composites/Modal/ModalContent.tsx#L45
  Modal: Platform.select({ default: 'alert', web: 'dialog' }) as AccessibilityRole,
  Main: Platform.select({ default: 'none', web: 'main' }) as AccessibilityRole,
  Heading: Platform.select({ default: 'header', web: 'heading' }) as AccessibilityRole,
  // SVGs should have role="img" according to https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Img_role#svg_and_roleimg
  // Note that in addition to setting accessibilityRole={A11Role.SvgImage} we should also add either
  // accessibilityLabelledBy or accessibilityLabel, and that accessibilityLabelledBy is preferred over
  // accessibilityLabel according to https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-labelledby
  SvgImage: Platform.select({ default: 'image', web: 'img' }) as AccessibilityRole,
}
